import { flatten } from "lodash";

interface BuildStringOptions {
  separator: string;
}

const defaultBuildStringOptions: BuildStringOptions = {
  separator: " ",
};

export function buildString(
  parts: (string | number | null | undefined)[] = [],
  options = defaultBuildStringOptions
): string {
  return parts.filter(Boolean).join(options.separator);
}

export function buildPath(paths: string[]): string {
  const sanitizedPaths = paths.map((path) => path.split("/"));
  return "/" + buildString(flatten(sanitizedPaths), { separator: "/" });
}
